<template>
  <el-select
    :disabled = "disabled"
    filterable
    remote
    value-key="id"
    v-model="order"
    :remote-method="loadOrderList"
    placeholder="输入商家名或店铺名或订单号搜索订单信息"
    @change="onChange"
    clearable
    :style="css">
    <el-option v-for="item in orderList"
      :key="item.id"
      :label="item.label"
      :value="item"/>
  </el-select>
</template>

<script>
export default {
  name: "MerchantOrderSearchComplex",

  props: ["id", "css", 'value', 'disabled'],

  data() {
    return {
      order: null,
      orderList: []
    };
  },

  watch: {
    id : function() {
      this.loadValue(this.id);
    },

    value : function() {
      this.loadValue( this.value );
    }
  },

  methods: {
    loadValue( _id ) {
      var _this = this;
      if ( !_id || _id == "") {
        return;
      }

      sdk.TicketOrderApi().findById_2({
        id : _id
      }).then((res) => {
         res.label = _this.orderLabel_1( res );

        _this.orderList = [];
        _this.orderList.push(res);
        _this.order = res;
      });
    },

    setValue( _val ) {
      this.order = _val;
    },

    loadOrderList( _query ) {
      var _this = this;
      sdk.TicketOrderApi().search_2({
        key: _query
      }).then(res => {
        if( !!res ) {
          _this.orderList = _this.orderLabel(res);
        }
      });
    },

    orderLabel_1( order ) {
      return order.merchantName + '(' + order.merchantCode + ', ' + order.merchantId + ')  -  ' // 
          + order.shopName + '(' + order.shopId + ')  -  ' // 
          + order.code + '(' + order.id + ')';
    },

    orderLabel( orders ) {
      for ( var i = 0; i < orders.length ; i++ ) {
        var order = orders[i];
        order.label = this.orderLabel_1(order);
      }

      return orders;
    },

    onChange( e ) {
      this.$emit('input', e.id);
      this.$emit("change", e);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/ticket/MerchantOrderSearchComplex.vue